import React from 'react';
import { useParams } from 'react-router-dom';
import IssueDetail from './IssueDetail';

export default function KeyedIssueDetail() {
  const { id } = useParams<{ id: string }>();
  return <IssueDetail key={id} />;
}
